import { render, staticRenderFns } from "./AddressDom.vue?vue&type=template&id=400455b4&scoped=true&"
import script from "./AddressDom.vue?vue&type=script&lang=js&"
export * from "./AddressDom.vue?vue&type=script&lang=js&"
import style0 from "./AddressDom.vue?vue&type=style&index=0&id=400455b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400455b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400455b4')) {
      api.createRecord('400455b4', component.options)
    } else {
      api.reload('400455b4', component.options)
    }
    module.hot.accept("./AddressDom.vue?vue&type=template&id=400455b4&scoped=true&", function () {
      api.rerender('400455b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/forms/AddressDom.vue"
export default component.exports